import ButtonT from '@components/tailwind-components/Button/ButtonT';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';
import { useWebclientActions } from '../../../../hooks/settings/webclients/useWebclientActions';

export const SetupWebclient: React.FC = () => {
  const { createWebclient } = useWebclientActions();
  const { hideModal } = useModal();
  const { t } = useTranslation();

  return (
    <div className='tailwind-modal-form'>
      <div className='tailwind-modal-body'>
        <p className='text-sm font-normal'>
          {t('settings.webclient.config.create.confirmation')}
        </p>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={() => {
            createWebclient();
            hideModal();
          }}>
          {t('general.buttons.create')}
        </ButtonT>
      </div>
    </div>
  );
};

export default SetupWebclient;
